export default __webpack_public_path__ + "static/media/juice-product.45abaae6.png";